import { Controller } from "@hotwired/stimulus"

// Device toggle del editor visual de paginas web.
// Replica el state client-side de src/websites/WebsiteEditorLayout.tsx
// (desktop/mobile/tablet) modificando las clases Tailwind del frame wrapper.
//
// Valores CSS (replican WebsiteEditorLayout.module.css):
//   desktop: position absolute inset 40px
//   mobile:  320x569 centrado con translate -50% + shadow
//   tablet:  1024x768 centrado con translate -50% + shadow
//
// Los botones (target "trigger") llevan un data-*-device-param con su
// tamano. El activo queda con bg #f2f2f2, el resto con bg white.

const DESKTOP_CLASSES = [
  "absolute", "top-[40px]", "right-[40px]", "left-[40px]", "bottom-[40px]"
]

const MOBILE_CLASSES = [
  "w-[320px]", "h-[569px]", "max-w-[80%]", "absolute",
  "left-1/2", "top-1/2", "-translate-x-1/2", "-translate-y-1/2",
  "shadow-[0_8px_15px_rgba(0,0,0,0.04),0_0_0_1px_rgba(0,0,0,0.04)]"
]

const TABLET_CLASSES = [
  "w-[1024px]", "h-[768px]", "max-w-[80%]", "absolute",
  "left-1/2", "top-1/2", "-translate-x-1/2", "-translate-y-1/2",
  "shadow-[0_8px_15px_rgba(0,0,0,0.04),0_0_0_1px_rgba(0,0,0,0.04)]"
]

const ALL_SIZE_CLASSES = [
  ...DESKTOP_CLASSES,
  ...MOBILE_CLASSES,
  ...TABLET_CLASSES
]

const SIZES = {
  desktop: DESKTOP_CLASSES,
  mobile:  MOBILE_CLASSES,
  tablet:  TABLET_CLASSES
}

export default class extends Controller {
  static targets = ["frame", "trigger"]
  static values = { size: { type: String, default: "desktop" } }

  set(event) {
    this.sizeValue = event.currentTarget.dataset.device
  }

  sizeValueChanged(newSize) {
    this.#updateFrame(newSize)
    this.#updateTriggers(newSize)
  }

  #updateFrame(size) {
    if (!this.hasFrameTarget) return
    const frame = this.frameTarget
    frame.classList.remove(...ALL_SIZE_CLASSES)
    frame.classList.add(...(SIZES[size] || DESKTOP_CLASSES))
  }

  #updateTriggers(size) {
    this.triggerTargets.forEach((btn) => {
      const isActive = btn.dataset.device === size

      if (isActive) {
        btn.classList.remove("bg-white")
        btn.classList.add("bg-[#f2f2f2]")
      } else {
        btn.classList.remove("bg-[#f2f2f2]")
        btn.classList.add("bg-white")
      }
    })
  }
}
